import StudentNameDatalist from "Components/StudentNameDatalist";
import { IStudentPickerProps } from "Interfaces/Props/IStudentPickerProps";
import StudentMap from "Models/StudentMap";
import React, { CompositionEventHandler, useState } from "react";
import { CloseButton, Col, Row } from 'react-bootstrap';

export function StudentPicker(props: IStudentPickerProps) {
	const [text, setText] = useState(props.target ?? "");
	const [isComposing, setIsComposing] = useState(false);
	
	const visible = typeof(props.visible) == "undefined" ? true : props.visible;
	const compose:CompositionEventHandler<HTMLInputElement> = (event) => {
		// console.log("UPDATE", event.type)
		switch (event.type) {
			case "compositionstart":
				setIsComposing(true);
				break;
			case "compositionend":
				setIsComposing(false);
				setTarget((event.target as HTMLInputElement).value, true);
				break;
		}
	}
	const setTarget = (student:string, force?:boolean) => {
		setText(student);
		if (!isComposing || force)
			props.setTarget(student);
	}
	const keydown:React.KeyboardEventHandler<HTMLInputElement> = (event) => {
		if (!isComposing && props?.handleKeyDown)
			props.handleKeyDown(event, setText);
	}
	const handleTextChange:React.ChangeEventHandler<HTMLInputElement> = (event) => {
		if (event.target.value === "/") return;
		if (props.ignoreNumericSpecials && !isComposing) {
			if (event.target.value !== "" && event.target.value[event.target.value.length-1].match(/[0-9\!\@\#\$\%\^\&\*\(\)]/g)) {
				event.target.value = event.target.value.substring(0, event.target.value.length-1);
				return;
			}
		}
		if (!isComposing && !props.disableAutofill) {
			const student = new StudentMap().getProperName(event.target.value);
			setTarget(student ?? event.target.value);
		} else {
			setTarget(event.target.value);
		}
	}

	const handleFocus = (event:React.ChangeEvent<HTMLInputElement>) => {
		event.target.select();
	}
	if (!visible) return null;
	
	  return (
	  <Row>
		<Col  className="justify-content-end">
			<label>
				Search
			</label>
			&nbsp;&nbsp;&nbsp;&nbsp;
			<input
				id={props.id ?? ""}
				className="search"
				type="text"
				name="studentName"
				list="studentNames"
				value={text}
				onCompositionStart={compose}
				onCompositionEnd={compose}
				onChange={handleTextChange}
				onFocus={handleFocus}
				onKeyDown={keydown}
				autoFocus={props.autoFocus}
			/>
			<CloseButton style={{marginLeft:5}} aria-label="Clear" onClick={()=>setTarget(null)}/>
			<StudentNameDatalist />
		</Col>
	  </Row>
	  );
}
